import styled from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

interface Wrapper {
  highlight?: boolean;
  color?: string;
}

interface Title {
  center?: boolean;
  block?: boolean;
}

interface Words {
  bold?: boolean;
}

export const WrapperPreviewPrint = styled.div`
  max-width: 288px;
  margin: 0 auto;
  box-sizing: border-box;
  font-family: ${FONTS.OPEN_SANS};
  width: 100%;
  min-height: 26px;
  background: #FFFFFF;
  border: 1px solid ${COLORS.GRAY_PLACEHOLDER};
  font-size: 12px;
  ${(props: Wrapper) => props.highlight && `
    background: ${COLORS.YELLOW_HIGHLIGHT};
  `}
`;

export const TitlePrint = styled.div`
  display: ${(props: Title) => props.block ? 'block': 'inline'};
  text-transform: uppercase;
  font-weight: 600;
  ${(props: Title) => props.center ? `
    display: block;
    text-align: center;
    font-size: 14px;
  `:`
    margin-right: 5px;
  `}
`;

export const WordPrint = styled.div`
  padding: 5px 9px;
  text-align: justify;
  line-height: 16px;
  font-weight: ${(props: Words) => props.bold ? '600' : '400' };
`;

export const StarWrapper = styled.span`
  margin-right: 4px;
`;

export const StarDoubleWrapper = styled.span`
  margin-left: 4px;
`;

export const Header = styled.div`
  background: #fff;
  border-width: 3px 0 3px 3px;
  border-color: #000;
  border-style: solid;
  font-size: 16px;
  position: relative;
  padding-left: 20px;
`;

export const IconCheckWrapper = styled.span`
  background: #000;
  position: absolute;
  left: -3px;
  width: 20px;
  text-align: center;
  height: 100%;
`;

export const  Vignette = styled.div`
  background: #fff;
  position: relative;
  box-sizing: border-box;
  border-width: 3px 0;
  border-color: #000;
  border-style: solid;
  display: flex;
  align-items: center;

  p {
    font-size: 19px;
  }
`;

export const IconEditWrapper = styled.span`
  background: ${(props: Wrapper) => props.color ? props.color : COLORS.GRAY_PLACEHOLDER};
  width: 24px;
  height: 24px;
  display: flex;
  position: absolute;
  right: 0;
  cursor: pointer;

  svg {
    margin: auto;
  }
`;

export const IconVignetteWrapper = styled.span`
  margin: 0 5px 0 11px;
`;